export default __webpack_public_path__ + "static/media/navbar-moderation-orange.a1db8f5a.svg";